// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"daajiMessage_scrollbar__dySyj","date":"daajiMessage_date__25pOI"};